import { useEffect, useState } from 'react';
import { fetchDebitNotePage, downloadDebitNote } from '../services/api';

const amount = (value: number, currency: string) => `${value.toLocaleString('fr-FR', {minimumFractionDigits: 2, maximumFractionDigits: 2})} ${currency}`;
const labels: Record<string,string> = {ISSUED:'Émise', PAID:'Payée', OVERDUE:'Échue', CANCELLED:'Annulée', PARTIALLY_PAID:'Partiellement payée'};
export default function DebitNotesPage() {
  const [page,setPage]=useState(1), [period,setPeriod]=useState(''), [refresh,setRefresh]=useState(0);
  const [data,setData]=useState<any>(null), [loading,setLoading]=useState(true), [error,setError]=useState('');
  const [downloading,setDownloading]=useState(''), [downloadError,setDownloadError]=useState('');
  useEffect(()=>{
    let stale=false;setLoading(true);setError('');
    fetchDebitNotePage(page,period).then(value=>{if(!stale)setData(value)}).catch(e=>{if(!stale)setError(e.message)}).finally(()=>{if(!stale)setLoading(false)});
    return ()=>{stale=true};
  },[page,period,refresh]);
  async function download(id:string){setDownloading(id);setDownloadError('');try{await downloadDebitNote(id)}catch(e:any){setDownloadError(e.message)}finally{setDownloading('')}}
  return <div className="page-content" style={{minWidth:0,maxWidth:'calc(100vw - 36px)'}}>
    <h1>Notes de débit</h1>
    <p>Les notes émises par l’ONT pour vos déclarations sont disponibles ici.</p>
    <div style={{display:'flex',gap:12,alignItems:'end',flexWrap:'wrap',margin:'20px 0'}}>
      <label>Période<input type="month" value={period} onChange={e=>{setPeriod(e.target.value);setPage(1)}} style={{display:'block'}} /></label>
      <button className="btn" onClick={()=>setRefresh(v=>v+1)}>Actualiser</button>
    </div>
    {downloadError&&<p role="alert">{downloadError}</p>}
    {loading?<p role="status">Chargement…</p>:error?<p role="alert">{error}</p>:data&&<>
      <p>{data.total} note(s) de débit</p>
      <div style={{overflowX:'auto'}}><table className="data-table" style={{width:'100%'}}><thead><tr>
        {['Note de débit','Déclaration','Période','Montant USD','Équivalent CDF','Échéance','Statut','Document'].map(label=><th key={label}>{label}</th>)}
      </tr></thead><tbody>{data.debit_notes.map((n:any)=><tr key={n.id}>
        <td>{n.debit_note_reference}</td><td>{n.declaration_reference}</td><td>{n.period}</td>
        <td>{amount(n.amount_due_usd,'USD')}</td><td>{amount(n.amount_due_cdf,'CDF')}</td>
        <td>{new Date(n.due_date).toLocaleDateString('fr-FR',{timeZone:'UTC'})}</td><td>{labels[n.status]||n.status}</td>
        <td><button className="btn" disabled={!!downloading} onClick={()=>download(n.id)}>{downloading===n.id?'Téléchargement…':'Télécharger le PDF'}</button></td>
      </tr>)}{data.total===0&&<tr><td colSpan={8}>Aucune note de débit pour cette période.</td></tr>}</tbody></table></div>
      <div style={{display:'flex',gap:12,marginTop:20,justifyContent:'flex-end',alignItems:'center'}}>
        <button className="btn" disabled={page<=1} onClick={()=>setPage(v=>v-1)}>Précédent</button>
        <span>Page {page} / {Math.max(1,data.total_pages)}</span>
        <button className="btn" disabled={page>=data.total_pages} onClick={()=>setPage(v=>v+1)}>Suivant</button>
      </div>
    </>}
  </div>;
}
